module.exports = __webpack_public_path__ + "img/p3.4fdb174b.png";